import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
var Container = styled('div')({
  verticalAlign: 'baseline'
});
var IconContainer = styled('span')({
  width: '36px',
  maxHeight: '27px',
  display: 'inline-block',
  marginRight: '7px'
});
var TitleContainer = styled('span')({
  display: 'inline-block'
});

var IconTitle = function IconTitle(_ref) {
  var icon = _ref.icon,
      children = _ref.children;
  return React.createElement(Container, null, React.createElement(IconContainer, null, icon), React.createElement(TitleContainer, null, children));
};

IconTitle.propTypes = process.env.NODE_ENV !== "production" ? {
  icon: PropTypes.node,
  children: PropTypes.node
} : {};
IconTitle.defaultProps = {
  icon: undefined,
  children: undefined
};
export default IconTitle;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/atoms/icon-title/index.js
// module id = 119
// module chunks = 0